import React from "react"
import { ThemeProvider } from "styled-components"

const theme = {
  maxWidth: "1375px",
  colors: {
    primary: "#f1f1f1",
    secondary: "#23e4036",
    highlight: "#11865a",
    opaque: "#8d8d8d",
    light: "#333",
    white: "#f1f1f1",
    trueWhite: "#fff",
    powderWhite: "#FFFDF9",
    //powderWhite: "rgb(249,249,249)",
    persianGreen: "#06B49A",
    lightBlue: "#AFDBD2",
    onyx: "#36313D",
    border: "#ccc",
    caption: "#999",
  },
  fonts: {
    heading: "Nunito",
    body: "Lato",
    alt: "Roboto",
  },
  fontSizes: {
    regular: "1rem",
    medium: "2rem",
    large: "3rem",
    heading: "2rem",
    h1: "3.052em",
    h2: "2.441em",
    h3: "1.953em",
    h4: "1.563em",
    h5: "1.25em",
    small: "0.8em",
  },
  padding: "0 1em",
}

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
)

export default Theme
